var FormaPago = new Map();
FormaPago.set("D", "Deposito Bancario");
FormaPago.set("W", "Vale Vista");
class FormaPagoHelper {
  getFormaPago (value) {    
    return FormaPago.get(value)
  }
}

export default new FormaPagoHelper()